@if (text !== undefined && text !== null) {
  {{ text | translate }}
} @else {
  @if (maxFiles && maxFiles > 0) {
    <span>
      {{ 'GALAXY.UPLOADER.CONSTRAINTS.MAX_FILES_PREFIX' | translate }}
      {{ maxFiles }}
    </span>
  }
  @if (acceptDisplay) {
    <span>{{ acceptDisplay }}</span>
  }
  @if (maxFileSize && maxFileSize > 0) {
    <span>
      @if (acceptDisplay || (maxFiles && maxFiles > 0)) {
        <span>.</span>
      }
      {{ fileSizeDisplay }}
      {{ 'GALAXY.UPLOADER.CONSTRAINTS.MAX_FILE_SIZE' | translate }}
    </span>
  }
}
